import React, { FC } from 'react';
import { Redirect, Switch } from 'react-router';
import { PrivateMfaSettingsRoute } from 'common/AuthRoute';
import { MfaSettingsPage } from 'pages/AccountManagement/MfaSettingsPage/MfaSettingsPage';
import { Layout } from 'antd';
import { Content } from 'common/StyledComponents';
import { MfaSettingsRoute } from 'routes';

export const AccountManagementRouter: FC = () => {
  return (
    <Layout>
      <Content style={{ minHeight: '40vh' }}>
        <Switch>
          <PrivateMfaSettingsRoute
            path={MfaSettingsRoute}
            component={MfaSettingsPage}
          />
          <Redirect to={`/`} />
        </Switch>
      </Content>
    </Layout>
  );
};
